export default __webpack_public_path__ + "static/down-1ebcd9614dea6955815b6c583c4e4d58.png";